import * as React from 'react';
import { TooltipBehavior } from './TooltipTypes';
export const TooltipDecorator = ({ content, behavior = TooltipBehavior.Hover, place = 'bottom', children }) => {
    if (isNullOrUndefined(children)) {
        return null;
    }
    if (isValidString(content) === false) {
        return children;
    }
    const tooltipAttributes = {
        'data-tooltip-id': behavior,
        'data-tooltip-place': place,
        'data-tooltip-content': content
    };
    return React.cloneElement(children, Object.assign({}, tooltipAttributes));
};
